class OrderService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getOrdersPage(params) {
    return this.apiService.get('/api/v1/orders', params);
  }

  getOrderById(id) {
    return this.apiService.get(`/api/v1/orders/${id}`);
  }

  deleteOrder(id) {
    return this.apiService.delete(`/api/v1/orders/${id}`);
  }

  deleteOrders(data) {
    return this.apiService.delete('/api/v1/orders', data);
  }

  updateOrder(order) {
    return this.apiService.put(`/api/v1/orders/${order.id}`, order);
  }

  sendOrderEmail(orderId, email) {
    return this.apiService.post(`/api/v1/orders/${orderId}/email/order-confirmation`, {address: email});
  }

  getOrderExportData(orderId) {
    return this.apiService.get(`/export/Auftragsverarbeitung/${orderId}`);
  }

  getOrderPositions(id) {
    return this.apiService.get(`/api/v1/orders/${id}/positions`);
  }

  deleteOrderPosition(orderId, positionId) {
    return this.apiService.delete(`/api/v1/orders/${orderId}/positions/${positionId}`);
  }

  createOrderPosition(orderId, position) {
    return this.apiService.post(`/api/v1/orders/${orderId}/positions`, position);
  }

  deleteOrderPositions(orderId, positionIds) {
    return this.apiService.put(`/api/v1/orders/${orderId}/positions`, {positionIds});
  }

  updateOrderPosition({orderId, positionId, position}) {
    return this.apiService.put(`/api/v1/orders/${orderId}/positions/${positionId}`, position);
  }

  copyOrderToCustomer({orderId, customerId}) {
    return this.apiService.post(`/api/v1/orders/${orderId}/copy/customers/${customerId}`);
  }
}

module.exports = OrderService;
